import Label from '@/atoms/inputs/Label';
import TextInput from '@/atoms/inputs/Text';
import Box from '@mui/material/Box';

const TextField = ({
  color,
  debounce,
  disabled,
  endAdornment,
  fullWidth,
  initialValue,
  label,
  maxLength,
  multiline,
  name,
  onBlur,
  onChange,
  onFocus,
  onKeyDown,
  optional,
  placeholder,
  rows,
  size,
  slotProps,
  variant,
  width,
}) => {
  return (
    <Box>
      <Label color={color}>
        {label}
        {optional && <span style={{ fontSize: '80%' }}> (optional)</span>}
      </Label>
      <TextInput
        color={color}
        debounce={debounce}
        disabled={disabled}
        endAdornment={endAdornment}
        fullWidth={fullWidth}
        initialValue={initialValue}
        maxLength={maxLength}
        multiline={multiline}
        name={name}
        onBlur={onBlur}
        onChange={onChange}
        onFocus={onFocus}
        onKeyDown={onKeyDown}
        placeholder={placeholder}
        rows={rows}
        size={size}
        slotProps={slotProps}
        variant={variant}
        width={width}
      />
    </Box>
  );
};

export default TextField;
